/**
 * Stable error codes of the user-impersonation flow (BR-AUTH-02/03).
 * Thrown by the backend as `CODE: technical detail` and consumed by the
 * frontend token interceptor, which decides between "drop the impersonation
 * token and fall back to the actor" (EXPIRED / REVOKED) and "just toast"
 * (ROUTE_FORBIDDEN). `IMPERSONATION_ERROR_I18N` is the single source that
 * maps each code to its i18n key.
 */
export const IMPERSONATION_ERROR_CODE = {
  FORBIDDEN: 'IMPERSONATION_FORBIDDEN',
  TARGET_NOT_FOUND: 'IMPERSONATION_TARGET_NOT_FOUND',
  TARGET_PRIVILEGED: 'IMPERSONATION_TARGET_PRIVILEGED',
  TENANT_INACTIVE: 'IMPERSONATION_TENANT_INACTIVE',
  NESTED: 'IMPERSONATION_NESTED',
  EXPIRED: 'IMPERSONATION_EXPIRED',
  REVOKED: 'IMPERSONATION_REVOKED',
  ROUTE_FORBIDDEN: 'IMPERSONATION_ROUTE_FORBIDDEN',
  SESSION_NOT_FOUND: 'IMPERSONATION_SESSION_NOT_FOUND',
} as const;

export type ImpersonationErrorCode =
  (typeof IMPERSONATION_ERROR_CODE)[keyof typeof IMPERSONATION_ERROR_CODE];

export const IMPERSONATION_ERROR_I18N: Record<ImpersonationErrorCode, string> = {
  [IMPERSONATION_ERROR_CODE.FORBIDDEN]: 'errors.impersonationForbidden',
  [IMPERSONATION_ERROR_CODE.TARGET_NOT_FOUND]: 'errors.impersonationTargetNotFound',
  [IMPERSONATION_ERROR_CODE.TARGET_PRIVILEGED]: 'errors.impersonationTargetPrivileged',
  [IMPERSONATION_ERROR_CODE.TENANT_INACTIVE]: 'errors.impersonationTenantInactive',
  [IMPERSONATION_ERROR_CODE.NESTED]: 'errors.impersonationNested',
  [IMPERSONATION_ERROR_CODE.EXPIRED]: 'errors.impersonationExpired',
  [IMPERSONATION_ERROR_CODE.REVOKED]: 'errors.impersonationRevoked',
  [IMPERSONATION_ERROR_CODE.ROUTE_FORBIDDEN]: 'errors.impersonationRouteForbidden',
  [IMPERSONATION_ERROR_CODE.SESSION_NOT_FOUND]: 'errors.impersonationSessionNotFound',
};
